import { getAPIErrorMessage } from 'api';
export const getBillingHistory = () => async (dispatch, getState, { api }) => {
    try {
        const { history } = await api.get_billing_history();
        return history;
    }
    catch (error) {
        return getAPIErrorMessage(error, 'Не удалось загрузить историю транзакций');
    }
};
